import { render, staticRenderFns } from "./UpdateUserGroup.vue?vue&type=template&id=0fa05a0a"
import script from "./UpdateUserGroup.vue?vue&type=script&lang=js"
export * from "./UpdateUserGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports